// LAS UTILIDADES DEL ESTADO DE UNA TERMINAL · DISEÑO-F5 §7.1
//
// Viven aparte de los componentes porque el lint de Fast Refresh
// (react-refresh/only-export-components) exige que un archivo con
// componentes no exporte otra cosa; aquí no hay JSX.
export const RAM_PISO_KB = 4;

export const esDeProducto = (t) => !!t?.serie;

/** «10:42» en la hora del teléfono. */
export function hora(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
}

export function kb(bytes) {
  if (bytes === null || bytes === undefined) return null;
  return `${(bytes / 1024).toFixed(1)} KB`;
}

export const SENAL_EN_PALABRAS = { BUENA: 'buena', REGULAR: 'regular', DEBIL: 'débil' };

/** Un problema que merece el chip «Con problema»: callada, memoria baja,
 *  robada o con cola sin enviar. */
export function tieneProblema(t) {
  if (!esDeProducto(t)) return false;
  return t.estado_v2 === 'CALLADA' || !!t.ram_baja || !!t.robada_en || (t.en_cola || 0) > 0;
}

export const COLOR_DE_ESTADO = {
  EN_LINEA: 'verde', SIN_RED: 'ambar', CALLADA: 'rojo', SIN_VINCULAR: 'gris', ROBADA: 'rojo', RETIRADA: 'gris',
};
